module.exports = __webpack_public_path__ + "img/pink-glow.4fe97fa4.svg";